

/**
 * GetPatrimonioChecklistMaquinaEquipByIdUseCase
 */

import { IGetPatrimonioChecklistMaquinaEquipByIdUseCase } from "../../../presentation/useCases/read/get_patrimonio_checklist_maquina_equip_by_id_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";
import { PatrimonioChecklistMaquinaEquipModel } from "../../models/patrimonio_checklist_maquina_equip";

export class GetPatrimonioChecklistMaquinaEquipByIdUseCase implements IGetPatrimonioChecklistMaquinaEquipByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getPatrimonioChecklistMaquinaEquipById(
    idPatrimonioChecklistMaquinaEquip: number,
  ): Promise<PatrimonioChecklistMaquinaEquipModel> {
    return await this.repository.getPatrimonioChecklistMaquinaEquipById(idPatrimonioChecklistMaquinaEquip);
  }
}
